import {
  REGISTER_USER,
  LOGIN_USER,
  CHECK_MEMBER_RESULT,
  OTP_CHECK_RESULT,
  LOGIN_USER_GOOGLE,
  FIND_PHONE_BY_EMAIL,
  FIND_EMAIL_BY_PHONE,
  FIND_PHONE_BY_EMAIL_FAILED,
  FIND_EMAIL_BY_PHONE_FAILED,
  ADD_USER_PHONE,
  NORMALIZE_USER_PHONE,
  ADD_USER_PHONE_FAILED,
  NORMALIZE_USER_PHONE_FAILED,
} from "./RLTypes";

export const LoginUserReducer = (
  state = {
    data: [],
    OTPCheck: false,
    Registered: false,
    CheckMember: undefined,
    whichDoing: undefined,
    FindPhoneResult: null,
    FindEmailResult: null,
    PhoneUpdateResult: null,
  },
  action,
) => {
  switch (action.type) {
    case CHECK_MEMBER_RESULT: {
      if (typeof action.Payload === "boolean") {
        return { ...state, CheckMember: action.Payload };
      }

      const { Exist, whichDoing } = action.Payload;

      return { ...state, CheckMember: Exist, whichDoing };
    }
    case LOGIN_USER: {
      return {
        ...state,
        data: {
          Error: false,
          userData: action.Payload.data,
          userToken: action.Payload.token ?? action.Payload.accessToken,
          userRefreshToken: action.Payload.refreshToken,
        },
      };
    }
    case LOGIN_USER_GOOGLE: {
      return {
        ...state,
        data: {
          Error: false,
          userData: action.userData.data,
          userToken: action.userData.token ?? action.userData.accessToken,
          userRefreshToken: action.userData.refreshToken,
        },
      };
    }
    case REGISTER_USER: {
      return {
        ...state,
        Registered: action.Payload,
      };
    }
    case OTP_CHECK_RESULT: {
      return { ...state, OTPCheck: action.Payload };
    }
    case FIND_PHONE_BY_EMAIL: {
      return { ...state, FindPhoneResult: action.Payload };
    }
    case FIND_EMAIL_BY_PHONE: {
      return { ...state, FindEmailResult: action.Payload };
    }
    case FIND_PHONE_BY_EMAIL_FAILED: {
      return { ...state, FindPhoneError: action.Payload };
    }
    case FIND_EMAIL_BY_PHONE_FAILED: {
      return { ...state, FindEmailError: action.Payload };
    }
    case ADD_USER_PHONE:
    case NORMALIZE_USER_PHONE: {
      return { ...state, PhoneUpdateResult: action.Payload };
    }
    case ADD_USER_PHONE_FAILED:
    case NORMALIZE_USER_PHONE_FAILED: {
      return { ...state, PhoneUpdateError: action.Payload };
    }
    default: {
      return state;
    }
  }
};
